module.exports = __webpack_public_path__ + "img/savings-bubble-6.9d0fc09f.png";